import { useEffect, useRef, useState } from "react";

/**
 * Live numbers sampled into a short rolling series for a chart: every
 * `everyMs` the latest values are appended, keeping the last `keep` samples
 * (two minutes by default). Each row has its clock time as `date`.
 */
export type LiveSample = { t: number; date: string } & Record<string, number | string>;

export const liveClock = (t: number) => new Date(t).toLocaleTimeString([], { hour: "numeric", minute: "2-digit", second: "2-digit" });

const useLiveSamples = (values: Record<string, number>, everyMs = 2000, keep = 60): LiveSample[] => {
  const latest = useRef(values);
  latest.current = values;
  const [samples, setSamples] = useState<LiveSample[]>(() => {
    const now = Date.now();
    return [{ t: now, date: liveClock(now), ...values }];
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = Date.now();
      setSamples((prev) => [...prev, { t: now, date: liveClock(now), ...latest.current }].slice(-keep));
    }, everyMs);
    return () => clearInterval(timer);
  }, [everyMs, keep]);

  return samples;
};

export default useLiveSamples;
